
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssociateConcernDebtFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssociateConcernDebt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bank_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sanction_bg_lc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sanction_tl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sanction_cc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oa_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oa_bg_lc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oa_tl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oa_cc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oa_roi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oa_asset_classification"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":198}};
    doc.loc.source = {"body":"fragment AssociateConcernDebtFields on AssociateConcernDebt {\n  id\n  bank_name\n  sanction_bg_lc\n  sanction_tl\n  sanction_cc\n  oa_date\n  oa_bg_lc\n  oa_tl\n  oa_cc\n  oa_roi\n  oa_asset_classification\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/AssociateConcernDebtFragment.graphql
// module id = 512
// module chunks = 0